export const GROUP_STAFF = 'staff';
export const GROUP_OWNER = 'owner';
export const GROUP_SUPER = 'super_admin';
export const GROUP_IT = 'it_admin';
export const GROUP_RBM = 'rbm';
export const GROUP_ABM = 'abm';
export const GROUP_RDR = 'rdr';
export const GROUP_KACE = 'kace';

export const REP_USER_GROUPS = [GROUP_RDR, GROUP_ABM, GROUP_RBM, GROUP_KACE];
